import { render } from "./Badge.vue?vue&type=template&id=5759721e"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5759721e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5759721e', __exports__)) {
    api.reload('5759721e', __exports__)
  }
  
  module.hot.accept("./Badge.vue?vue&type=template&id=5759721e", () => {
    api.rerender('5759721e', render)
  })

}


export default __exports__